import { ComponentDecoratorImageProps } from './types';
import { ICON_SPACE } from './constants';

export const getIconWidth = (imageProps: ComponentDecoratorImageProps) => {
  const { iconId, shapeId, imgSrc } = imageProps;
  return (iconId && iconId !== 'none') || shapeId || imgSrc ? ICON_SPACE : 0;
};
